// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cCZc","name":"styles_name__2fJB8","phone":"styles_phone__Qu3E6"};